<template lang="pug">
.dialog-container
  .row
    p {{ $t('Player report for network ') }} {{ networkName }}. {{ this.$store.state.Device.desktop_list.length }} {{ $t('players in network') }}.
  .row(v-if='excelReport.length === 0 && !loading')
    .row
      el-checkbox(v-model='includeMediaData')
        span {{ $t('Include media data')}}
      el-checkbox(v-model='includeAdvancedDetails')
        span {{ $t('Include hardware and configuration data')}}
      el-checkbox(v-model='includeWarrantyDetails')
        span {{ $t('Include Warranty details')}}
      br
      br
      el-button(id="platerReport-GenrateButton", type='success', size="mini", :title='$t("Generate player report")', @click='loadData()')
        span {{ $t('Generate report') }}
    //- .row
    //-   br
    //- .row
    //-   el-checkbox(v-model='limitToCache')
    //-     span {{ $t('Limit to filtered players')}}
  download-excel(v-if='excelReport.length > 0 && !loading', :data = "excelReport", :title='getExcelHeader', :name='getExcelFilename')
    el-button(id="LedReport-downloadExcelButton", type='text', size="mini", :title='$t("Download excel file")')
      span.warning {{ $t('Your report is ready. Click here to download') }} &nbsp;
      font-awesome-icon.medium-icon(icon="download")
  .row(v-if='loading')
    p.warning {{ loadingMessage }}
</template>

<script>
import Vue from 'vue'
import downloadExcel from 'vue-json-excel'
import textUtils from '../Common/textUtils.mixin'
export default {
  mixins: [textUtils],
  props: [],
  components: {
    downloadExcel
  },
  data () {
    return {
      errors: {
      },
      loading: false,
      loadingMessage: '',
      localPlayListsMediaNames: new Map(),
      lastTenDownloadsFailureRate: new Map(),
      lastDownloads: [],
      formatedDesktops: [],
      limitToCache: false,
      includeMediaData: true,
      includeAdvancedDetails: true,
      includeWarrantyDetails: true
    }
  },
  methods: {
    async loadData () {
      this.loading = true
      if (this.includeMediaData) await this.getLocalPlayListsMediaNames()
      if (this.includeMediaData) await this.getLastTenContentDownloadsForDesktops()
      this.loadingMessage = 'Rendering report...'
      await this.getDesktopList()
      this.loading = false
    },
    async getLocalPlayListsMediaNames () {
      let done = 0
      const todo = this.$store.state.Device.desktop_list.length
      for (const dktp of this.$store.state.Device.desktop_list) {
        const localPlaylistMediaIdsArray = (await Vue.axios.get(`medium/${dktp.LocalPlayList}?populate=PlayListItems`)).data.PlayListItems.map(pli => pli.Medium)
        const mediaNamesOnLocalPlaylist = this.$store.state.Medium.media_list
          .filter(m => localPlaylistMediaIdsArray.includes(m.id))
          .map(m => m.name)
          .join(', ')
        this.localPlayListsMediaNames.set(dktp.id, mediaNamesOnLocalPlaylist)
        done++
        this.loadingMessage = 'Getting content info...' + `${parseInt((done / todo) * 100, 10)}%`
      }
    },
    async getLastTenContentDownloadsForDesktops () {
      let done = 0
      const todo = this.$store.state.Device.desktop_list.length
      for (const dktp of this.$store.state.Device.desktop_list) {
        // TODO: sortby createdAt
        const contentDownloads = (await Vue.axios.get(`contentdownload?ContentDownloadDeviceDesktop=${dktp.id}&populate=false&sort=id DESC&limit=10`)).data
        const failedCountPercentage = contentDownloads.length ? parseInt((contentDownloads.filter(cd => cd.failed).length / contentDownloads.length) * 100, 10) + '%' : '-'
        this.lastTenDownloadsFailureRate.set(dktp.id, failedCountPercentage)
        done++
        this.loadingMessage = 'Getting downloads info...' + `${parseInt((done / todo) * 100, 10)}%`
      }
    },
    async getDesktopList () {
      const extraHBDataMap = this.lookupExtraHBData()
      let properties
      if (this.includeAdvancedDetails) {
        properties = this.includeAdvancedDetails ? (await Vue.axios.get(`deviceproperty/list`)).data : []
      }
      let i = 0
      for (const dktp of this.$store.state.Device.desktop_list) {
        const group = this.lookupDeviceDesktopGroup(dktp.DeviceDesktopGroup)
        const device = this.$store.state.Device.device_list.find(d => d.id === dktp.Device)

        const desktop = (({
          id,
          concatedname,
          createdAt,
          uuid,
          HBip,
          alive,
          HBuptime,
          HBcontentDownloadId
        }) => ({
          'id': id,
          'Localization': group.name,
          'Player Name': concatedname.replace('single', ''),
          'Localization created': group.createdAt ? this.$moment(group.createdAt).format('YYYY-MM-DD HH:mm:ss') : '',
          'Address': group.address,
          'Player created': this.$moment(createdAt).format('YYYY-MM-DD HH:mm:ss'),
          'Player Description': device.description,
          'UUID': uuid,
          'IP': HBip,
          'Online status': alive ? 'OK' : 'OFFLINE',
          'Last device start': HBuptime ? this.$moment(Date.now() - (HBuptime * 1000)).format('YYYY-MM-DD HH:mm:ss') : '-',
          'Downloaded content Id': HBcontentDownloadId || ''
        }))(dktp)

        if (!this.includeAdvancedDetails) {
          delete desktop['Localization created']
          delete desktop['Address']
          delete desktop['UUID']
          delete desktop['IP']
          delete desktop['Last device start']
          delete desktop['Downloaded content Id']
          delete desktop['Online status']
        }

        let desktopWithAdditionalData = {}
        if (this.includeWarrantyDetails) {
          // may also include { product_type, manufacturer, product_number } if needed
          // eslint-disable-next-line camelcase
          let { warranty_date, installation_date } = (await Vue.axios.post(`device/infoFromChaos`, { id: dktp.Device })).data
          // eslint-disable-next-line camelcase
          desktopWithAdditionalData['Installation Model'] = extraHBDataMap.get(dktp.id).model
          // eslint-disable-next-line camelcase
          desktopWithAdditionalData['Installation date'] = installation_date
          // eslint-disable-next-line camelcase
          desktopWithAdditionalData['Warranty expires'] = warranty_date
          // eslint-disable-next-line camelcase
        }
        if (this.includeMediaData) {
          desktopWithAdditionalData['Content synchronization in progress'] = this.lastContentDownload(desktop) ? this.lastContentDownload(desktop).progress < 100 ? 'YES' : 'NO' : ''
          desktopWithAdditionalData['Last successful content synchronization'] = this.lastSuccessfulContentDownload(desktop)
          desktopWithAdditionalData['Last 10 content synchronizations fail rate'] = this.lastTenDownloadsFailureRate.get(desktop.id)
          desktopWithAdditionalData['Media on Local playlist'] = this.localPlayListsMediaNames.get(desktop.id)
        }
        if (this.includeAdvancedDetails) {
          desktopWithAdditionalData['Player Properties'] = this.formatDeviceProperties(properties.filter(p => p.Device === device.id))
          desktopWithAdditionalData = {
            ...desktopWithAdditionalData,
            ...extraHBDataMap.get(dktp.id)
          }
        }
        desktopWithAdditionalData = {
          ...desktop,
          ...desktopWithAdditionalData
        }
        delete desktopWithAdditionalData.id
        this.formatedDesktops.push(desktopWithAdditionalData)
        i++
        this.loadingMessage = `Rendering report... ${parseInt((i / this.$store.state.Device.desktop_list.length) * 100, 10)}%`
      }
    },
    formatDeviceProperties (properties) {
      const arrayToString = []
      const objectsArray = properties.map(({ Device, id, updatedAt, createdAt, ...keepAttrs }) => keepAttrs)
      for (const object of objectsArray) {
        arrayToString.push(`${object.name}: ${object.body}`)
      }
      return arrayToString.join('\n')
    },
    lastContentDownload (desktop) {
      if (!desktop) return
      const desktopDownloads = this.$store.state.Device.content_downloads
        .filter(cd => cd.ContentDownloadDeviceDesktop === desktop.id)
      return desktopDownloads[desktopDownloads.length - 1]
    },
    lastSuccessfulContentDownload (desktop) {
      if (!desktop) return
      const desktopDownloads = this.$store.state.Device.content_downloads
        .filter(cd => cd.ContentDownloadDeviceDesktop === desktop.id && cd.progress === 100)
      if (desktopDownloads.length === 0) {
        return '-'
      } else {
        return this.$moment(desktopDownloads.pop().updatedAt).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    lookupDeviceDesktopGroup (id) {
      const group = this.$store.state.Device.device_desktop_groups.find(ddg => ddg.id === id)
      return group || { name: null, createdAt: null }
    },
    lookupExtraHBData () {
      // creates Map() of extraHB uniform objects for easier rendering:
      // If no property reported in HB for a device empty string value is assigned
      const extraHBMap = new Map()
      let allExistingExtraHBKeys = []
      for (const dktp of this.$store.state.Device.desktop_list) {
        if (dktp.extraHB) {
          allExistingExtraHBKeys = [...new Set([...allExistingExtraHBKeys, ...Object.keys(JSON.parse(dktp.extraHB))])]
        }
      }
      for (const dktp of this.$store.state.Device.desktop_list) {
        let extraHBObject = {}
        for (const key of allExistingExtraHBKeys) {
          extraHBObject[key] = ''
        }
        if (!dktp.extraHB) {
          extraHBMap.set(dktp.id, extraHBObject)
        } else {
          const ddExtraHBData = JSON.parse(dktp.extraHB)
          for (const key of allExistingExtraHBKeys) {
            if (ddExtraHBData[key]) {
              extraHBObject[key] = typeof ddExtraHBData[key] === 'string' ? ddExtraHBData[key] : JSON.stringify(ddExtraHBData[key])
            } else {
              extraHBObject[key] = ''
            }
          }
          extraHBMap.set(dktp.id, extraHBObject)
        }
      }
      return extraHBMap
    }
  },
  computed: {
    getExcelHeader () {
      return `Players in Network ` +
       this.networkName +
       ' - ' + this.$moment().format('YYYY-MM-DD HH:mm:ss')
    },
    getExcelFilename () {
      return `Player report ` +
       this.networkName +
       ' - ' + this.$moment().format('YYYY-MM-DD HH:mm:ss')
    },
    networkName () {
      return this.$store.state.User.user.Networks.find(network => network.id === this.$store.state.User.user.lastNetworkId).name
    },
    excelReport () {
      return this.formatedDesktops
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.dialog-container {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/DeviceReport.vue